import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {
  SupportClearingDataLoadingService
} from "../../../../services/support/support-clearing/support-clearing-data-loading.service";
import {Clearing} from "../../../../model/clearing/clearing";
import {SupportClearingService} from "../../../../services/support/support-clearing/support-clearing.service";
import {
  SupportClearingBatchFormConfigService
} from "../../../../services/support/support-clearing/support-clearing-batch-form-config.service";
import {BatchUpdateRequest} from "../../../../model/api/batch-update-request";
import {BatchActionBaseFormComponent} from "../../../../crystal-elements/batch-action-base-form.component";
import {DecimalPipe} from "@angular/common";
import {PrepareForSaveDateFields} from "../../../../utils/form-helper";

@Component({
  selector: 'app-batch-action-support-clearing-form',
  templateUrl: './batch-action-support-clearing-form.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MessageService, ConfirmationService, TranslateService, DecimalPipe]
})
export class BatchActionSupportClearingFormComponent
  extends BatchActionBaseFormComponent<Clearing, SupportClearingBatchFormConfigService> {

  @Input()
  dataLoadingService: SupportClearingDataLoadingService

  constructor(
    cdref: ChangeDetectorRef,
    messageService: MessageService,
    translateService: TranslateService,
    confirmationService: ConfirmationService,
    formConfigService: SupportClearingBatchFormConfigService,
    private readonly supportClearingService: SupportClearingService
  ) {
    super(
      cdref,
      messageService,
      translateService,
      confirmationService,
      formConfigService
    );
  }

  protected getSaveAction(request: BatchUpdateRequest<Clearing>) {
    PrepareForSaveDateFields(request.recordToApply, this.formConfig);
    return this.supportClearingService.saveBatch(request);
  }
}
